import moment from "moment";
import { autoFitColumns } from "utils/DownloadExcel";
import { getVatNameByVatID } from "utils/HelperFunction";
import { utils, writeFileXLSX } from "xlsx";
export default function useDoExport() {
    function mappingReportDOItemData(param) {
        var datas = param.datas, primaryData = param.primaryData;
        var mappingData = datas.filter(function(v) {
            return v.productQty > 0;
        }).map(function(v, i) {
            var mapping = {
                "ลำดับที่* ": 1,
                วันที่เอกสาร: moment(primaryData.doc_issue_date).format("YYYYMMDD"),
                เลขที่เอกสาร: "",
                อ้างอิงถึง: primaryData.doc_number,
                ลูกค้า: primaryData.factMember.customer_id,
                "เลขทะเบียน 13 หลัก": "",
                "เลขสาขา 5 หลัก": "",
                เป็นใบกำกับภาษี: 1,
                ประเภทราคา: primaryData.dim_mst_price_category_id,
                "สินค้า/บริการ": v.productBarcode,
                บัญชี: "",
                คำอธิบาย: "",
                จำนวน: v.productQty,
                ราคาต่อหน่วย: v.productPrice,
                ส่วนลดต่อหน่วย: v.discount,
                อัตราภาษี: getVatNameByVatID({
                    vatID: v.dim_mst_vat_id
                }),
                "ถูกหัก ณ ที่จ่าย (ถ้ามี)": "",
                หมายเหตุ: v.note,
                กลุ่มจัดประเภท: ""
            };
            return mapping;
        });
        return mappingData;
    }
    function downloadExcel(param) {
        var datas = param.datas, primaryData = param.primaryData, filename = param.filename;
        if (!primaryData || !Array.isArray(datas) || datas.length === 0) {
            console.warn("No data to export.");
            return;
        }
        var mappingData = mappingReportDOItemData({
            datas: datas,
            primaryData: primaryData,
            filename: filename
        });
        if (!mappingData || mappingData.length === 0) {
            console.warn("Mapping returned no data.");
            return;
        }
        var wb = utils.book_new();
        var ws = utils.json_to_sheet(mappingData);
        ws["!cols"] = autoFitColumns(mappingData, ws);
        utils.book_append_sheet(wb, ws, filename);
        writeFileXLSX(wb, "".concat(filename, ".xlsx"));
    }
    return {
        downloadExcel: downloadExcel
    };
}
